var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-popups"},[(_vm.visiblePopupKey === 'notificationIntroductionPopup')?_c('portal',{attrs:{"to":"confirm-modal"}},[_c('notification-introduction-popup',{on:{"close":function($event){return _vm.onPopupClose('notificationIntroductionPopup')}}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }